<div fxLayout="column">
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else userRegistrationFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="userRegistrationFlexColumnTemplate"></ng-container>
    </div>
</div>

<ng-template #userRegistrationFlexColumnTemplate>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing"
        [ngClass]="{ 'ie-display': isBrowserIE }">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else userRegistrationMessagesFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="userRegistrationMessagesFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else userRegistrationMainFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="userRegistrationMainFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #userRegistrationMessagesFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <!-- Instruction Messages -->
    <div fxFlex="90%" fxLayoutAlign="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
        class="large-paragraph-pre-spacing" *ngIf="showInstructionMessagesSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" class="large-paragraph-pre-spacing"
        *ngIf="!showInstructionMessagesSpinner && this.instructionMessageList.length > 0">
        <div ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
            ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
            class="extra-large-display-text normal-paragraph-spacing center-text" [ngClass]="getMessageCssClass(item)"
            *ngFor="let item of this.instructionMessageList">
            {{ item.messageText }}
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #userRegistrationMainFlexColumnTemplate>
    <div fxFlex="50%" fxHide.lt-md></div>
    <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div *ngIf="isBrowserIE; else userRegistrationFormFlexColumnTemplate">
                            <ng-container *ngTemplateOutlet="userRegistrationFormFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #userRegistrationFormFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-dark-color-important">
            <b><span i18n="@@user-registration.form.title">user-registration.form.title</span></b>
        </div>
        <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSecurityQuestionsListSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div class="display-text" *ngIf="!showSecurityQuestionsListSpinner">
            <ng-container *ngTemplateOutlet="userRegistrationFormPart1FlexColumnTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="userRegistrationFormPart2FlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #userRegistrationFormPart1FlexColumnTemplate>
    <form [formGroup]="userRegistrationFormPart1">
        <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.social-security-number.placeholder"
                        placeholder="user-registration.form.social-security-number.placeholder" type="text"
                        [formControl]="socialSecurityNumberFormControl" autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.socialSecurityNumberMaxLength" required
                        onkeypress="return isNumberKey(this, event, 0)" />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.social-security-number">user-registration.form.hint.social-security-number</mat-hint>
                    <mat-error *ngIf="socialSecurityNumberFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                    <mat-error *ngIf="
              (socialSecurityNumberFormControl.hasError('minlength') || socialSecurityNumberFormControl.hasError('maxlength')) &&
              !socialSecurityNumberFormControl.hasError('required')
            " i18n="@@user-registration.form.error.social-security-number">user-registration.form.error.social-security-number</mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.social-security-number.placeholder"
                        placeholder="user-registration.form.social-security-number.placeholder" type="text"
                        [value]="maskSocialSecurityNumber(userInformation.ssn)" autocomplete="off" readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="!registrationVerified">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                    <input matInput
                        i18n-placeholder="@@user-registration.form.confirm-social-security-number.placeholder"
                        placeholder="user-registration.form.confirm-social-security-number.placeholder" type="text"
                        [formControl]="confirmSocialSecurityNumberFormControl" autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.socialSecurityNumberMaxLength" required
                        onkeypress="return isNumberKey(this, event, 0)" />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.confirm-social-security-number">user-registration.form.hint.confirm-social-security-number</mat-hint>
                    <mat-error *ngIf="confirmSocialSecurityNumberFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                    <mat-error *ngIf="
              (confirmSocialSecurityNumberFormControl.hasError('minlength') ||
                confirmSocialSecurityNumberFormControl.hasError('maxlength')) &&
              !confirmSocialSecurityNumberFormControl.hasError('required')
            " i18n="@@user-registration.form.error.social-security-number">user-registration.form.error.social-security-number</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing" *ngIf="
          socialSecurityNumberEqualsFormControl.invalid &&
          socialSecurityNumberEqualsFormControl.hasError('required') &&
          !registrationVerified
        ">
                <span ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" fxLayoutAlign="left start">
                    <mat-error class="form-error"
                        *ngIf="socialSecurityNumberEqualsFormControl.invalid && socialSecurityNumberEqualsFormControl.hasError('required')"
                        i18n="@@user-registration.form.social-security-number-equals.error">user-registration.form.social-security-number-equals.error</mat-error>
                </span>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.first-name.placeholder"
                        placeholder="user-registration.form.first-name.placeholder" type="text"
                        [formControl]="firstNameFormControl" autocomplete="given-name"
                        [maxlength]="fieldValidations.userRegistration.firstNameMaxLength" required />
                    <mat-error *ngIf="firstNameFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.first-name.placeholder"
                        placeholder="user-registration.form.first-name.placeholder" type="text"
                        [value]="userInformation.firstName" autocomplete="off" readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.last-name.placeholder"
                        placeholder="user-registration.form.last-name.placeholder" type="text"
                        [formControl]="lastNameFormControl" autocomplete="family-name"
                        [maxlength]="fieldValidations.userRegistration.lastNameMaxLength" required />
                    <mat-error *ngIf="lastNameFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.last-name.placeholder"
                        placeholder="user-registration.form.last-name.placeholder" type="text"
                        [value]="userInformation.lastName" autocomplete="off" readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.middle-initial.placeholder"
                        placeholder="user-registration.form.middle-initial.placeholder" type="text"
                        [formControl]="middleInitialFormControl" autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.middleInitialMaxLength" />
                    <mat-error *ngIf="middleInitialFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.middle-initial.placeholder"
                        placeholder="user-registration.form.middle-initial.placeholder" type="text"
                        [value]="userInformation.middleInitial" autocomplete="off" readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.date-of-birth.placeholder"
                        placeholder="user-registration.form.date-of-birth.placeholder"
                        [formControl]="dateOfBirthFormControl" autocomplete="bday"
                        [min]="fieldValidationsDateOfBirthMinValue" [max]="fieldValidationsDateOfBirthMaxValue"
                        [matDatepicker]="dateOfBirthPicker" onkeypress="return isDateKey(this, event, true, false)"
                        required />
                    <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfBirthPicker></mat-datepicker>
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.date-of-birth">user-registration.form.hint.date-of-birth</mat-hint>
                    <mat-error *ngIf="dateOfBirthFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.date-of-birth.required">user-registration.form.error.date-of-birth.required</mat-error>
                    <mat-error
                        *ngIf="dateOfBirthFormControl.hasError('matDatepickerMin') && !dateOfBirthFormControl.hasError('required')">
                        <span
                            i18n="@@user-registration.form.error.date-of-birth.min">user-registration.form.error.date-of-birth.min</span>
                        {{ fieldValidationsDateOfBirthMinValue | date: 'MM/dd/yyyy' }}</mat-error>
                    <mat-error
                        *ngIf="dateOfBirthFormControl.hasError('matDatepickerMax') && !dateOfBirthFormControl.hasError('required')">
                        <span
                            i18n="@@user-registration.form.error.date-of-birth.max">user-registration.form.error.date-of-birth.max</span>
                        {{ fieldValidationsDateOfBirthMaxValue | date: 'MM/dd/yyyy' }}</mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.date-of-birth.placeholder"
                        placeholder="user-registration.form.date-of-birth.placeholder"
                        [value]="userInformation.birthDate" autocomplete="off" [matDatepicker]="dateOfBirthPicker"
                        readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                    <mat-datepicker #dateOfBirthPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.username.placeholder"
                        placeholder="user-registration.form.username.placeholder"
                        type="text"
                        [formControl]="userNameFormControl"
                        autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.userNameMaxLength"
                        required />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.username">user-registration.form.hint.username
                    </mat-hint>
                    <mat-error *ngIf="userNameFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required
                    </mat-error>
                    <!-- <mat-error *ngIf="(userNameFormControl.hasError('minlength') ||
                                       userNameFormControl.hasError('maxlength')) &&
                                       !userNameFormControl.hasError('required')"
                                i18n="@@user-registration.form.error.username">
                                user-registration.form.error.username
                    </mat-error> -->
                    <mat-error *ngIf="userNameFormControl.hasError('pattern')"
                               i18n="@@user-registration.form.error.usernamepattern">
                               user-registration.form.error.usernamepattern
                    </mat-error>
                </mat-form-field>
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="registrationVerified">
                    <input matInput i18n-placeholder="@@user-registration.form.username.placeholder"
                        placeholder="user-registration.form.username.placeholder" type="text"
                        [value]="userInformation.userName" autocomplete="off" readonly disabled />
                    <mat-icon matSuffix>done</mat-icon>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center"
                class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing"
                *ngIf="!registrationVerified">
                <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}"
                    required></re-captcha>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                *ngIf="!registrationVerified">
                <button mat-flat-button color="primary" (click)="verifyRegistration()" [disabled]="!verifyEnabled()"
                    i18n="@@user-registration.form.verify-button.label">
                    user-registration.form.verify-button.label
                </button>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                *ngIf="showVerifyRegistrationSpinner">
                <mat-spinner color="accent" diameter="32"></mat-spinner>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyErrorParticipantId">
                <b><span
                        i18n="@@user-registration.verify-message.error.participant-id.1">user-registration.verify-message.error.participant-id.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyErrorParticipantId">
                <b><span
                        i18n="@@user-registration.verify-message.error.participant-id.2">user-registration.verify-message.error.participant-id.2</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyErrorRegisteredFlag">
                <b><span
                        i18n="@@user-registration.verify-message.error.registered-flag.1">user-registration.verify-message.error.registered-flag.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyErrorRegisteredFlag">
                <b><span
                        i18n="@@user-registration.verify-message.error.registered-flag.2">user-registration.verify-message.error.registered-flag.2</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing"
                *ngIf="showVerifyErrorDuplicateUserNameFlag">
                <b><span
                        i18n="@@user-registration.verify-message.error.duplicate-user-name-flag.1">user-registration.verify-message.error.duplicate-user-name-flag.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing"
                *ngIf="showVerifyErrorDuplicateUserNameFlag">
                <b><span
                        i18n="@@user-registration.verify-message.error.duplicate-user-name-flag.2">user-registration.verify-message.error.duplicate-user-name-flag.2</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyError">
                <b><span
                        i18n="@@user-registration.verify-message.error.1">user-registration.verify-message.error.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showVerifyError">
                <b><span
                        i18n="@@user-registration.verify-message.error.2">user-registration.verify-message.error.2</span></b>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #userRegistrationFormPart2FlexColumnTemplate>
    <form [formGroup]="userRegistrationFormPart2">
        <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-pre-spacing"
                *ngIf="registrationVerified">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                    <input matInput i18n-placeholder="@@user-registration.form.password.placeholder"
                        placeholder="user-registration.form.password.placeholder" type="password"
                        [formControl]="userPasswordFormControl" autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.passwordMaxLength" required />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.password">user-registration.form.hint.password</mat-hint>
                    <mat-error *ngIf="userPasswordFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                    <mat-error
                        *ngIf="userPasswordFormControl.hasError('pattern') && !userPasswordFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.password">user-registration.form.error.password</mat-error>
                </mat-form-field>
            </div>
            <br>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="registrationVerified">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                    <input matInput i18n-placeholder="@@user-registration.form.confirm-password.placeholder"
                        placeholder="user-registration.form.confirm-password.placeholder" type="password"
                        [formControl]="confirmUserPasswordFormControl" autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.passwordMaxLength" required />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.confirm-password">user-registration.form.hint.confirm-password</mat-hint>
                    <mat-error *ngIf="confirmUserPasswordFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                    <mat-error
                        *ngIf="confirmUserPasswordFormControl.hasError('pattern') && !confirmUserPasswordFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.confirm-password">user-registration.form.error.confirm-password</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                *ngIf="userPasswordEqualsFormControl.invalid && userPasswordEqualsFormControl.hasError('required')">
                <span ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" fxLayoutAlign="left start">
                    <mat-error class="form-error"
                        *ngIf="userPasswordEqualsFormControl.invalid && userPasswordEqualsFormControl.hasError('required')"
                        i18n="@@user-registration.form.password-equals.error">user-registration.form.password-equals.error</mat-error>
                </span>
            </div>
            <br>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="registrationVerified">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                    <mat-select i18n-placeholder="@@user-registration.form.security-question.label"
                        placeholder="user-registration.form.security-question.label"
                        [formControl]="securityQuestionFormControl"
                                       autocomplete="off"
                                       required>
                        <mat-option *ngFor="let item of securityQuestionsList" value="{{ item.securityQuestionId }}">{{
                            item.securityQuestion
                            }}</mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="tooltip-icon" matTooltip="{{ getToolTip('securityQuestion') }}"
                        matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    <mat-error *ngIf="securityQuestionFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                </mat-form-field>
            </div>
            <br>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="registrationVerified">
                <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                    <input matInput i18n-placeholder="@@user-registration.form.security-question-answer.placeholder"
                        placeholder="user-registration.form.security-question-answer.placeholder"
                        type="text"
                        [formControl]="securityQuestionAnswerFormControl"
                        autocomplete="off"
                        [maxlength]="fieldValidations.userRegistration.securityQuestionAnswerMaxLength"
                        required />
                    <mat-hint align="end"
                        i18n="@@user-registration.form.hint.security-question-answer">user-registration.form.hint.security-question-answer</mat-hint>
                    <mat-error *ngIf="securityQuestionAnswerFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.required">user-registration.form.error.required</mat-error>
                    <mat-error *ngIf="securityQuestionAnswerFormControl.hasError('pattern') && !securityQuestionAnswerFormControl.hasError('required')"
                        i18n="@@user-registration.form.error.security-answer">user-registration.form.error.security-answer</mat-error>
                </mat-form-field>
            </div>
            <br>

            <div fxLayout="row" fxLayoutAlign="center center"
                class="large-display-text highlighted-display-text normal-paragraph-spacing" *ngIf="showLoginButton">
                <b><span
                        i18n="@@user-registration.submit-message.success.1">user-registration.submit-message.success.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center"
                class="display-text highlighted-display-text normal-paragraph-spacing" *ngIf="showLoginButton">
                <b><span
                        i18n="@@user-registration.submit-message.success.2">user-registration.submit-message.success.2</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showSubmitError">
                <b><span
                        i18n="@@user-registration.submit-message.error.1">user-registration.submit-message.error.1</span></b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text warning-color normal-paragraph-spacing" *ngIf="showSubmitError">
                <b><span
                        i18n="@@user-registration.submit-message.error.2">user-registration.submit-message.error.2</span></b>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text large-paragraph-spacing"
                *ngIf="registrationVerified && !showLoginButton && !userAgreed">
                <b><span i18n="@@user-registration.agree-message.1">user-registration.agree-message.1</span>&nbsp;
                    <a (click)="openLink(companyInformation.consentDisclosureURL, 'consentDisclosureURL')"
                        class="anchor-link accent-color-important"
                        i18n="@@user-registration.agree-message.consent-disclosure-link.label">user-registration.agree-message.consent-disclosure-link.label</a>.
                    &nbsp;
                    <span i18n="@@user-registration.agree-message.2">user-registration.agree-message.2</span>
                </b>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                class="display-text large-paragraph-spacing"
                *ngIf="registrationVerified && !showLoginButton && userAgreed">
                <b><span i18n="@@user-registration.submit-message.1">user-registration.submit-message.1</span>&nbsp;
                    <a (click)="openLink(companyInformation.termsConditionsURL, 'termsConditionsURL')"
                        class="anchor-link accent-color-important"
                        i18n="@@user-registration.submit-message.terms-conditions-link.label">user-registration.submit-message.terms-conditions-link.label</a>&nbsp;<span
                        i18n="@@user-registration.submit-message.2">user-registration.submit-message.2</span>&nbsp;<a
                        (click)="openLink(companyInformation.privacyPolicyURL, 'privacyPolicyURL')"
                        class="anchor-link accent-color-important"
                        i18n="@@user-registration.submit-message.privacy-policy-link.label">user-registration.submit-message.privacy-policy-link.label</a>.
                    &nbsp;<span i18n="@@user-registration.submit-message.3">user-registration.submit-message.3</span>
                </b>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                *ngIf="registrationVerified && !showSubmitSpinner && !showLoginButton">
                <button mat-flat-button color="primary" (click)="userAgreement()"
                    i18n="@@user-registration.form.agree-button.label" [disabled]="!agreeEnabled()" *ngIf="!userAgreed">
                    user-registration.form.agree-button.label
                </button>
                <button mat-flat-button color="primary" (click)="submitUser()"
                    i18n="@@user-registration.form.submit-button.label" [disabled]="!submitEnabled()"
                    *ngIf="userAgreed">
                    user-registration.form.submit-button.label
                </button>
                &nbsp;&nbsp;
                <button mat-stroked-button color="primary" (click)="resetRegistration()"
                    i18n="@@user-registration.form.reset-button.label">
                    user-registration.form.reset-button.label
                </button>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                *ngIf="showSubmitSpinner && !showLoginButton">
                <mat-spinner color="accent" diameter="32"></mat-spinner>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                *ngIf="showLoginButton">
                <button mat-flat-button color="primary" (click)="openLogin()"
                    i18n="@@user-registration.form.login-button.label">
                    user-registration.form.login-button.label
                </button>
            </div>
        </div>
    </form>
</ng-template>
